<template>
  <div class="figures-container" aria-hidden="true">
    <StaticAsset folder="images" file="character-stills_00.png" />
    <StaticAsset folder="images" file="character-stills_03.png" />
  </div>
</template>

<style scoped>
.figures-container {
  position: relative;

  img {
    position: absolute;
    top: 0;

    &:nth-child(2) {
      left: 6rem;
      top: 3rem;
    }
  }
}
</style>
